// WCAG 1.4.13 (Content on Hover or Focus) — allow the CSS `.tooltip__content` tooltips
// to be dismissed with the Escape key without moving the pointer or focus. The tooltip
// re-appears the next time its trigger is hovered or focused.
const DISMISSED = "tooltip--dismissed"

const closestTooltip = node =>
  node && typeof node.closest === "function" ? node.closest(".tooltip") : null

const dismissActiveTooltips = () => {
  const tips = new Set()

  const focusedTip = closestTooltip(document.activeElement)
  if (focusedTip) tips.add(focusedTip)

  try {
    document.querySelectorAll(".tooltip:hover").forEach(tip => tips.add(tip))
  } catch (e) {
    // `:hover` is not queryable in every environment (e.g. jsdom); the focus path
    // still covers keyboard users, which is what Escape-to-dismiss is for.
  }

  tips.forEach(tip => tip.classList.add(DISMISSED))
}

// Let the tooltip appear again once focus or the pointer leaves it entirely.
const clearIfLeaving = e => {
  const tip = closestTooltip(e.target)
  if (tip && !tip.contains(e.relatedTarget)) tip.classList.remove(DISMISSED)
}

const init = () => {
  document.addEventListener("keydown", e => {
    if (e.key === "Escape" || e.key === "Esc") dismissActiveTooltips()
  })
  document.addEventListener("focusout", clearIfLeaving)
  document.addEventListener("mouseout", clearIfLeaving)
}

export default { init }
